import { Card, CardContent, Typography, Box, Stack } from '@mui/material';

export function TeacherDashboardCard({ title, value, subtitle, icon: Icon, color = 'primary', onClick }) {
  return (
    <Card 
      onClick={onClick}
      sx={{ 
        height: '100%', 
        borderRadius: 3,
        ...(onClick && {
          cursor: 'pointer',
          transition: 'transform 0.2s, box-shadow 0.2s',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: 4
          }
        })
      }}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Stack direction="row" sx={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ flex: 1, minWidth: 0, pr: 2 }}>
            <Typography color="text.secondary" variant="subtitle2" fontWeight={600} gutterBottom>
              {title}
            </Typography>
            <Typography variant="h3" fontWeight={700} color="text.primary">
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              width: 48,
              height: 48,
              flexShrink: 0,
              borderRadius: 2,
              bgcolor: `${color}.light`,
              color: `${color}.main`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon size={24} />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
